import { BaseService } from "./BaseService";
import { Measures } from "../types/app.interfaces";
import { FunctionGroup, MeasuresType } from "../types/app.enums";

export class MeasuresService extends BaseService {
  burgissCalcUnfunded(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Unfunded,
        dynamicParameter,
        investId,
        [],
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcUnfunded",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Unfunded,
        dynamicParameter,
        [],
        [],
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcUnfunded",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Unfunded,
        dynamicParameter,
        [],
        investId,
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcUnfunded",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcValuation(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        investId,
        [],
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcValuation",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        [],
        [],
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcValuation",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        [],
        investId,
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcValuation",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcDistributions(
    investId: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Dist,
        dynamicParameter,
        investId,
        [],
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributions",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Dist,
        dynamicParameter,
        [],
        [],
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributions",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Dist,
        dynamicParameter,
        [],
        investId,
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributions",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcCommitment(
    investId: any[][],
    endDate?: any,
    currency?: string,
    filter?: any,
    idType?: string,
    selectionSetId?: any,
    dynamicParameter?: string,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.BaseCommitment,
        dynamicParameter,
        investId,
        [],
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcCommitment",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.BaseCommitment,
        dynamicParameter,
        [],
        [],
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcCommitment",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.BaseCommitment,
        dynamicParameter,
        [],
        investId,
        null,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcCommitment",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcStock(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Stock,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcStock",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Stock,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcStock",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Stock,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcStock",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcFees(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Fees,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcFees", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Fees,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcFees", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Fees,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcFees", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }

  BurgissCalcCash(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Cash,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcCash", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Cash,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcCash", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Cash,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcCash", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }

  BurgissCalcIRR(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRR,
        dynamicParameter,
        investId,
        [],
        beginDate,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRR,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRR,
        dynamicParameter,
        [],
        investId,
        beginDate,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }
  BurgissCalcRIRR(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.RIRR,
        dynamicParameter,
        investId,
        [],
        beginDate,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcRIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.RIRR,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcRIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.RIRR,
        dynamicParameter,
        [],
        investId,
        beginDate,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcRIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }

  BurgissCalcDPI(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,

    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DPI,
        dynamicParameter,
        investId,
        [],
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcDPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DPI,
        dynamicParameter,
        [],
        [],
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcDPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DPI,
        dynamicParameter,
        [],
        investId,
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcDPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }

  BurgissCalcTVPI(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.TVPI,
        dynamicParameter,
        investId,
        [],
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcTVPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.TVPI,
        dynamicParameter,
        [],
        [],
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcTVPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.TVPI,
        dynamicParameter,
        [],
        investId,
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcTVPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }

  BurgissCalcRVPI(
    investId: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.RVPI,
        dynamicParameter,
        investId,
        [],
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcRVPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.RVPI,
        dynamicParameter,
        [],
        [],
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcRVPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.RVPI,
        dynamicParameter,
        [],
        investId,
        null,
        rollForward,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation("BurgissCalcRVPI", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }

  BurgissCalcTWRR(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.Twrr,
        dynamicParameter,
        investid,
        [],
        beginDate,
        rollForward
      );
      return super._pushOperation("BurgissCalcTWRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.Twrr,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward
      );
      return super._pushOperation("BurgissCalcTWRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.Twrr,
        dynamicParameter,
        [],
        investid,
        beginDate,
        rollForward
      );
      return super._pushOperation("BurgissCalcTWRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }

  BurgissCalcCostBasis(
    investid: any[][],
    beginDate?: any,
    endDate?: any,
    currency?: string,
    rollForward?: string,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CostBasis,
        dynamicParameter,
        investid,
        [],
        beginDate,
        rollForward
      );
      return super._pushOperation(
        "BurgissCalcCostBasis",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CostBasis,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward
      );
      return super._pushOperation(
        "BurgissCalcCostBasis",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CostBasis,
        dynamicParameter,
        [],
        investid,
        beginDate,
        null,
        rollForward
      );
      return super._pushOperation(
        "BurgissCalcCostBasis",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcFunding(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filters?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filters,
        idType,
        selectionSetID,
        MeasuresType.Funding,
        dynamicParameter,
        investid,
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcFunding",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filters,
        idType,
        selectionSetID,
        MeasuresType.Funding,
        dynamicParameter,
        [],
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcFunding",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filters,
        idType,
        selectionSetID,
        MeasuresType.Funding,
        dynamicParameter,
        [],
        investid,
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcFunding",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcPaidIn(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filters?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filters,
        idType,
        selectionSetID,
        MeasuresType.Paidin,
        dynamicParameter,
        investid,
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcPaidIn",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filters,
        idType,
        selectionSetID,
        MeasuresType.Paidin,
        dynamicParameter,
        [],
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcPaidIn",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filters,
        idType,
        selectionSetID,
        MeasuresType.Paidin,
        dynamicParameter,
        [],
        investid,
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcPaidIn",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcFundSize(
    investid?: any[][],
    endDate?: any,
    currency?: any,
    useAlternateFundSize?: any,
    uniqueCellId?: string
  ) {
    const objRequest = this.createPayload(
      uniqueCellId,
      investid,
      null,
      endDate,
      currency,
      null,
      "i",
      "0",
      MeasuresType.PooledFundSize,
      null,
      [],
      [],
      null,
      null,
      useAlternateFundSize
    );
    return super._pushOperation(
      "BurgissCalcFundSize",
      objRequest,
      this.APICONFIG.GETINVESTMENTS,
      FunctionGroup.Measures
    );
  }
  BurgissCalcCashOther(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashOther,
        dynamicParameter,
        investid,
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashOther",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashOther,
        dynamicParameter,
        [],
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashOther",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashOther,
        dynamicParameter,
        [],
        investid,
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcCashOther",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcCashReturnofCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashReturnOfCapital,
        dynamicParameter,
        investid,
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashReturnofCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashReturnOfCapital,
        dynamicParameter,
        [],
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashReturnofCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashReturnOfCapital,
        dynamicParameter,
        [],
        investid,
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashReturnofCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCashCapitalGains(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashCapitalGains,
        dynamicParameter,
        investid,
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCashCapitalGains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashCapitalGains,
        dynamicParameter,
        [],
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCashCapitalGains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashCapitalGains,
        dynamicParameter,
        [],
        investid,
        beginDate
      );
      return super._pushOperation(
        "BurgissCashCapitalGains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcCashIncome(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashIncome,
        dynamicParameter,
        investid,
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashIncome",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashIncome,
        dynamicParameter,
        [],
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashIncome",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashIncome,
        dynamicParameter,
        [],
        investid,
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashIncome",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcCashRecallableCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashRecallableCapital,
        dynamicParameter,
        investid,
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashRecallableCapital,
        dynamicParameter,
        [],
        [],
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CashRecallableCapital,
        dynamicParameter,
        [],
        investid,
        beginDate
      );
      return super._pushOperation(
        "BurgissCalcCashRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcDistributionsOther(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistOther,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsOther",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistOther,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsOther",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistOther,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsOther",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcDistributionsRecallableCapital(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistRecallableCapital,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistRecallableCapital,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistRecallableCapital,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcDistributionsCapitalgains(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistCapitalGains,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsCapitalgains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistCapitalGains,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsCapitalgains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistCapitalGains,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsCapitalgains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcDistributionsReturnofCapital(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistReturnOfCapital,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsReturnofCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistReturnOfCapital,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsReturnofCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistReturnOfCapital,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsReturnofCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcDistributionsIncome(
    investId: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistIncome,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsIncome",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistIncome,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsIncome",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }

    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DistIncome,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternatebasecurrrency
      );
      return super._pushOperation(
        "BurgissCalcDistributionsIncome",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  burgissCalcValuationDate(
    investId?: any[][],
    endDate?: any,
    rollForward?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        null,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        investId,
        [],
        null,
        rollForward
      );
      return super._pushOperation(
        "BurgissVALUATIONDATE",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        null,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        [],
        [],
        null,
        rollForward
      );
      return super._pushOperation(
        "BurgissVALUATIONDATE",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        null,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        [],
        investId,
        null,
        rollForward
      );
      return super._pushOperation(
        "BurgissVALUATIONDATE",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcAdjustedCommitment(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Adjustedcommitment,
        dynamicParameter,
        investId,
        [],
        null,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcAdjustedCommitment",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Adjustedcommitment,
        dynamicParameter,
        [],
        [],
        null,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcAdjustedCommitment",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Adjustedcommitment,
        dynamicParameter,
        [],
        investId,
        null,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcAdjustedCommitment",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcNetCapitalContributed(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.NetCapitalContributed,
        dynamicParameter,
        investId,
        [],
        beginDate,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcNetCapitalContributed",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.NetCapitalContributed,
        dynamicParameter,
        [],
        [],
        beginDate,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcNetCapitalContributed",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.NetCapitalContributed,
        dynamicParameter,
        [],
        investId,
        beginDate,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcNetCapitalContributed",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcValuationRollForward(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        investId,
        [],
        null,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcValuationRollForward",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        [],
        [],
        null,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcValuationRollForward",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.Valuation,
        dynamicParameter,
        [],
        investId,
        null,
        null,
        null,
        alternateCurrrency
      );
      return super._pushOperation(
        "BurgissCalcValuationRollForward",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcLN_ICMIRR(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRRICMMultiIndex,
        dynamicParameter,
        investId,
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMIRR",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRRICMMultiIndex,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMIRR",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRRICMMultiIndex,
        dynamicParameter,
        [],
        investId,
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMIRR",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcLN_ICMIRRSpread(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRRSpreadMultiIndex,
        dynamicParameter,
        investId,
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMIRRSPREAD",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRRSpreadMultiIndex,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMIRRSPREAD",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.IRRSpreadMultiIndex,
        dynamicParameter,
        [],
        investId,
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMIRRSPREAD",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcLN_ICMValuation(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.ICMValuationMultiIndex,
        dynamicParameter,
        investId,
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMVALUATION",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.ICMValuationMultiIndex,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMVALUATION",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.ICMValuationMultiIndex,
        dynamicParameter,
        [],
        investId,
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcLN_ICMVALUATION",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcKS_PME(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.KSPMEMultiIndex,
        dynamicParameter,
        investId,
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcKS_PME",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.KSPMEMultiIndex,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcKS_PME",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.KSPMEMultiIndex,
        dynamicParameter,
        [],
        investId,
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcKS_PME",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcGGS_DirectAlpha(
    investId?: any[][],
    index?: any,
    premium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DirectAlphaMultiIndex,
        dynamicParameter,
        investId,
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcGGS_DIRECTALPHA",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DirectAlphaMultiIndex,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcGGS_DIRECTALPHA",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.DirectAlphaMultiIndex,
        dynamicParameter,
        [],
        investId,
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        index,
        premium
      );
      return super._pushOperation(
        "BurgissCalcGGS_DIRECTALPHA",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  burgissCalcMIRR(
    investId?: any[][],
    financeIndexId?: any,
    financeIndexPremium?: any,
    reinvestmentIIndexId?: any,
    reinvestmentIIndexPremium?: any,
    endDate?: any,
    currency?: string,
    rollForward?: any,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    dynamicParameter?: string,
    alternateCurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.MIRRMultiIndex,
        dynamicParameter,
        investId,
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        null,
        null,
        financeIndexId,
        financeIndexPremium,
        reinvestmentIIndexId,
        reinvestmentIIndexPremium
      );
      return super._pushOperation("BurgissCalcMIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investId,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.MIRRMultiIndex,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        null,
        null,
        financeIndexId,
        financeIndexPremium,
        reinvestmentIIndexId,
        reinvestmentIIndexPremium
      );
      return super._pushOperation("BurgissCalcMIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetId,
        MeasuresType.MIRRMultiIndex,
        dynamicParameter,
        [],
        investId,
        beginDate,
        rollForward,
        null,
        alternateCurrrency,
        null,
        null,
        financeIndexId,
        financeIndexPremium,
        reinvestmentIIndexId,
        reinvestmentIIndexPremium
      );
      return super._pushOperation("BurgissCalcMIRR", objRequest, this.APICONFIG.GETINVESTMENTS, FunctionGroup.Measures);
    }
    return null;
  }
  BurgissCalcCostBasisFXGainLoss(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CostBasisFXGainLoss,
        dynamicParameter,
        investid,
        [],
        beginDate,
        rollForward
      );
      return super._pushOperation(
        "BurgissCalcCostBasisFXGainLoss",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CostBasisFXGainLoss,
        dynamicParameter,
        [],
        [],
        beginDate,
        rollForward
      );
      return super._pushOperation(
        "BurgissCalcCostBasisFXGainLoss",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.CostBasisFXGainLoss,
        dynamicParameter,
        [],
        investid,
        beginDate,
        rollForward
      );
      return super._pushOperation(
        "BurgissCalcCostBasisFXGainLoss",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }
  BurgissCalcStockCapitalGains(
    investid?: any[][],
    endDate?: any,
    currency?: string,
    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockCapitalGains,
        dynamicParameter,
        investid,
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockCapitalGains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockCapitalGains,
        dynamicParameter,
        [],
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockCapitalGains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockCapitalGains,
        dynamicParameter,
        [],
        investid,
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockCapitalGains",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcStockCost(
    investid?: any[][],
    endDate?: any,
    currency?: string,

    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockCost,
        dynamicParameter,
        investid,
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockCost",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockCost,
        dynamicParameter,
        [],
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockCost",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockCost,
        dynamicParameter,
        [],
        investid,
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockCost",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcStockRecallableCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,

    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockRecallableCapital,
        dynamicParameter,
        investid,
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockRecallableCapital,
        dynamicParameter,
        [],
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockRecallableCapital,
        dynamicParameter,
        [],
        investid,
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockRecallableCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  BurgissCalcStockReturnOfCapital(
    investid?: any[][],
    endDate?: any,
    currency?: string,

    beginDate?: any,
    idType?: string,
    selectionSetID?: any,
    filter?: any,
    dynamicParameter?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockReturnOfCapital,
        dynamicParameter,
        investid,
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockReturnOfCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        uniqueCellId,
        investid,
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockReturnOfCapital,
        dynamicParameter,
        [],
        [],
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockReturnOfCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        uniqueCellId,
        [],
        null,
        endDate,
        currency,
        filter,
        idType,
        selectionSetID,
        MeasuresType.StockReturnOfCapital,
        dynamicParameter,
        [],
        investid,
        beginDate,
        null
      );
      return super._pushOperation(
        "BurgissCalcStockReturnOfCapital",
        objRequest,
        this.APICONFIG.GETINVESTMENTS,
        FunctionGroup.Measures
      );
    }
    return null;
  }

  createPayload(
    alias: string = null,
    investId: any[][] = null,
    attributeName: string = null,
    endDate: any = null,
    currency: string = null,
    filter: any = "",
    idType: string = null,
    selectionSetId: any = null,
    measure: string = null,
    dynamicParameter: any = null,
    portfolioId: any[][] = null,
    assetId: any[][] = null,
    beginDate: any = null,
    rollForward: string = null,
    useAlternateFundSize: any = null,
    alternateCurrrency: string = null,
    index: any = null,
    premium: any = null,
    financeIndexId: any = null,
    financeIndexPremium: any = null,
    reinvestmentIIndexId: any = null,
    reinvestmentIIndexPremium: any = null
  ) {
    const measuresObject: Measures = {
      excludeBalanceSheetItems: false,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: financeIndexId,
      financePremium: financeIndexPremium,
      reinvestmentIndexID: reinvestmentIIndexId,
      reinvestmentPremium: reinvestmentIIndexPremium,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      returnConstituentCount: false,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      portfolioID: String(portfolioId).toUpperCase() == "ALL" ? "-1" : String(portfolioId),
      isHoldingCalc: false,
      returnPooledResult: true,
      baseCurrency: currency == null || String(currency).toLowerCase() === "true" ? true : false,
      alternateBaseCurrency: alternateCurrrency,
      adjustToMostRecent: rollForward != null ? Boolean(rollForward) : false,
      measure: measure,
      beginDate: beginDate,
      endDate: endDate,
      year: null,
      indexID: index,
      premium: premium,
      idType: idType,
      selectionsetID: selectionSetId,
      assetID: String(assetId).toUpperCase() == "ALL" ? "-1" : String(assetId),
      weightingMethod: null,
      value: null,
      filter: filter,
      attributeName: attributeName,
      rankValue: null,
      bMUHistoricalWindowLengthQtrs: 0,
      maxAgeDiffYears: null,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      numSimulations: null,
      desiredSampleSize: null,
      minSampleSize: null,
      sampleStatistic: null,
      stopOn: null,
      requireReportedValuation: 0,
      alias: alias,
      currencyHedgesetId: null,
      foFLookThrough: false,
      useReceivedDate: false,
      excludeFrozenAsset: true,
      useAlternateFundSize: useAlternateFundSize != null ? Boolean(useAlternateFundSize) : false,
      dynamicParameter: dynamicParameter,
      universe: null,
      weight: null,
      commitment: null,
    };
    return measuresObject;
  }
}
